import { apiSlice } from '@services/apiSlice';
import { Webinars as endpoints } from '@services/endpoints';
import { WebinarLandingItem, WebinarPage } from './Webinars.types';

interface WebinarBannerResponse {
  webinarLandingItems: WebinarLandingItem[];
}

const webinarsApi = apiSlice
  .injectEndpoints({
    endpoints: (build) => ({
      fetchWebinarBanner: build.query<WebinarLandingItem, void>({
        query: () => ({
          url: endpoints.fetchWebinarBanner,
          params: { lang: window.lang, pageId: window.pageId },
        }),
        transformResponse(baseQueryReturnValue: WebinarBannerResponse) {
          return baseQueryReturnValue.webinarLandingItems[0];
        },
      }),
      fetchWebinarPage: build.query<WebinarPage, void>({
        query: () => ({
          url: endpoints.fetchWebinarList,
          params: { lang: window.lang },
        }),
      }),
    }),
    overrideExisting: false,
  })

export const { useFetchWebinarBannerQuery, useFetchWebinarPageQuery } = webinarsApi;